<template>
  <div class="container d-flex justify-content-center align-items-center mt-4">
    <div class="logo-container">
      <img
        class="img-fluid img-size-control"
        src="@/assets/ft-logo-login.png"
        width="300"
        alt="Falcon - Soluções Inteligentes"
      />
    </div>
    <div class="login">
      <div v-if="submitSuccess">
        <div class="row mb-3">
          <h1 class="h1-bem-vindo poppins-light">
            SOLICITAÇÃO
            <span class="poppins-semibold">ENVIADA</span>
          </h1>
          <h2 class="h2-slogan poppins-light">
            Sua solicitação foi recebida. O administrador irá analisá-la em breve e você receberá as instruções de acesso.
          </h2>
        </div>
        <div class="extand-login-button">
          <span></span>
          <router-link to="/login" class="btn btn-secondary">Voltar ao login</router-link>
        </div>
      </div>

      <form v-else @submit.prevent="submit">
        <div class="row mb-3">
          <h1 class="h1-bem-vindo poppins-light">
            SOLICITAR
            <span class="poppins-semibold">ACESSO</span>
          </h1>
          <h2 class="h2-slogan poppins-light">
            Preencha os dados abaixo para solicitar acesso ao sistema
          </h2>
        </div>

        <div class="row">
          <div class="form-group">
            <label for="nome" class="label-login">Nome completo</label>
            <input
              type="text"
              class="form-control"
              id="nome"
              v-model="form.nome"
              required
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <label for="email" class="label-login">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              v-model="form.email"
              required
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <label for="uf" class="label-login">Estado (UF)</label>
            <select
              class="form-control"
              id="uf"
              v-model="form.uf"
              @change="onUfChange"
              required
            >
              <option value="">Selecione o estado...</option>
              <option v-for="uf in ufs" :key="uf.sigla" :value="uf.sigla">
                {{ uf.sigla }} - {{ uf.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <label for="municipio" class="label-login">Município</label>
            <select
              class="form-control"
              id="municipio"
              v-model="selectedMunicipio"
              required
              :disabled="!form.uf || loadingMunicipios"
            >
              <option :value="null">
                {{ loadingMunicipios ? 'Carregando...' : 'Selecione o município...' }}
              </option>
              <option v-for="m in municipios" :key="m.id" :value="m">
                {{ m.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="extand-login-button">
            <router-link to="/login" class="link-login">Já tenho acesso</router-link>
            <button type="submit" class="btn btn-secondary" :disabled="loading">
              {{ loading ? 'Enviando...' : 'Solicitar acesso' }}
            </button>
          </div>
        </div>
      </form>

      <div v-if="error" class="row mt-3">
        <div class="col-md-12">
          <div class="alert alert-danger fade show" role="alert">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import axios from "axios";
import axiosApi from "@/axios";
import Footer from "@/components/Footer.vue";

const IBGE_API = "https://servicodados.ibge.gov.br/api/v1/localidades";

export default {
  name: "SolicitarAcesso",
  components: { Footer },
  data() {
    return {
      form: {
        nome: "",
        email: "",
        uf: "",
      },
      selectedMunicipio: null,
      ufs: [],
      municipios: [],
      loadingMunicipios: false,
      loading: false,
      error: "",
      submitSuccess: false,
    };
  },
  async created() {
    try {
      const response = await axios.get(`${IBGE_API}/estados?orderBy=nome`);
      this.ufs = response.data.map((uf) => ({ sigla: uf.sigla, nome: uf.nome }));
    } catch {
      this.error = "Não foi possível carregar os estados. Tente novamente.";
    }
  },
  methods: {
    async onUfChange() {
      this.selectedMunicipio = null;
      this.municipios = [];
      if (!this.form.uf) return;

      this.loadingMunicipios = true;
      try {
        const response = await axios.get(
          `${IBGE_API}/estados/${this.form.uf}/municipios`
        );
        this.municipios = response.data.map((m) => ({
          id: String(m.id),
          nome: m.nome,
        }));
      } catch {
        this.error = "Não foi possível carregar os municípios. Tente novamente.";
      } finally {
        this.loadingMunicipios = false;
      }
    },
    async submit() {
      this.error = "";
      if (!this.selectedMunicipio) {
        this.error = "Selecione um município.";
        return;
      }

      this.loading = true;
      try {
        await axiosApi.post("/api/solicitacoes", {
          nome: this.form.nome,
          email: this.form.email,
          uf: this.form.uf,
          municipio_ibge_codigo: this.selectedMunicipio.id,
          municipio_nome: this.selectedMunicipio.nome,
        });
        this.submitSuccess = true;
      } catch (err) {
        this.error = err.response?.data?.message || "Erro ao enviar solicitação. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.link-login {
  color: inherit;
  text-decoration: none;
  font-size: 0.9rem;
}

.link-login:hover {
  text-decoration: underline;
}
</style>
